import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Notification from "./Notification"


const NotificationsTable = ({ heading, links }) => {
  return (
    <>
      <Wrapper>
        <Heading>{heading}</Heading>
        {links.map((link) => <Notification {...link} key={link.title} />)}
      </Wrapper>
    </>
  );
}

NotificationsTable.propTypes = {
  heading: PropTypes.string.isRequired,
  links: PropTypes.array.isRequired,
};

// ********** Styled Components ********** //


let Wrapper = styled.div`

  // Margin & Padding
  margin: 0;
  padding: 0;
  
  // Sizing
  width: 100%;
  
    // Large phones and below
  @media only screen and (max-width : 414px) {


  }
`;


const Heading = styled.h2`

  // Margin & Padding
  margin: 0 0 var(--spacer-3) 0;
  padding: 0; // TODO Check
  
  // Positioning
  position: relative;
  //bottom: 2px;
  
  // Display
  display: block;
  
  // Fonts
  font-family: var(--headerFont);
  font-style: normal;
  font-weight: bold;
  font-size: var(--font-5);
  line-height: 1.5;
  text-align: center;
  text-transform: uppercase;
  
  // Border
  //border-top: 3px solid var(--textRed);
  
  // Colors
  color: var(--textRed);
  
  // Others
  z-index: 2;
  
      // Large phones and below
  @media only screen and (max-width : 544px) {
    font-size: var(--font-5);
  }
`;


export default NotificationsTable
